// src/reducers/certificadoReducer.js
import { CERT_FETCH_REQ, CERT_FETCH_OK, CERT_FETCH_ERR } from '../actions/certificadoActions';

const initial = {
  loading: false,
  error: null,
  data: null,   // aquí llega el certificado + { verificacion: { vigente, hoy, dias_restantes } }
};

export default function certificadoReducer(state = initial, action) {
  switch (action.type) {
    case CERT_FETCH_REQ:
      return { ...state, loading: true, error: null };
    case CERT_FETCH_OK:
      return { ...state, loading: false, data: action.payload, error: null };
    case CERT_FETCH_ERR:
      return { ...state, loading: false, error: action.error || 'Error', data: null };
    default:
      return state;
  }
}
